<template>
	<section class="accounting-by-subsidiary">
		<header-page
			actions
			name="accounting-accounts"
			:title="title"
		></header-page>
		<div>
			<div v-if="loadingAcc" class="text-xs-center title-modal">
				Espera un momento para ver el plan de cuentas.
			</div>
			<accounting-account-table
				class="px-5 my-5 mobile-table-accounting"
				v-else
				:rows="table.rows"
				table-height="0"
				@add-account="addAccount"
				@delete-account="openConfirmation"
				@edit-account="editAccount"
				@row-expanded="rowExpanded"
			>
				<template v-for="column in columns" slot="header">
					<v-flex
						class="header-table-text"
						:class="column.class || 'xs4'"
						:key="column.id"
						text-xs-center
					>
						{{ column.name }}
					</v-flex>
				</template>
			</accounting-account-table>
		</div>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="dialog"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{ dialogMessage }}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<v-btn
						type="button"
						@click="closeDialog"
						color="success"
						class="btn-action mr-1 white--text">
						Cancelar
					</v-btn>
					<v-btn
						type="button"
						color="error"
						@click="onDelete"
						class="btn-action ml-1 white--text">
						Eliminar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<router-view></router-view>
	</section>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import accountingAccountTable from '@/components/accounting-accounts/accounting-account-table';

	async function created() {
		if (this.isPeru) {
			this.columns = [
				{
					id: 1,
					class: 'xs6',
					name: 'Código',
					value: 'account',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 2,
					class: 'xs4',
					name: 'Descripción',
					value: 'description',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 3,
					class: 'xs2',
					name: 'Acciones',
					checked: true,
					visible: true,
					flagVisible: true,
					movil: false,
				},
			];
		}
		this.loadingAcc = true;
		if (!this.subsidiaryId) {
			const dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
			const params = {
				customerId: dataUserInfo ? dataUserInfo.subsidiary.customerId : null,
			};
			await this.$loadSubsidiaries({ context: this, params });
			const subsidiary = this.getGlobalSubsidiaries[1];
			this.$setCurrentSubsidiary(subsidiary);
			this.subsidiaryId = subsidiary.id;
		}
		this.params.tree = true;
		delete this.params.page;
		delete this.params.limit;
		this.loadData(`accounting-plan/${this.subsidiaryId}/subsidiary`);
	}

	function addAccount({ id, accountingPlanId, name }) {
		this.goTo(
			'accounting-account-by-subsidiary-new',
			{
				params: {
					accountId: id,
					id: accountingPlanId,
					name,
					subsidiaryName: this.subsidiaryName,
					route: 'accounting-accounts-by-subsidiary',
				},
			},
		);
	}

	function closeDialog() {
		this.dialog = false;
		this.dialogMessage = '';
		this.accountId = null;
	}

	function editAccount({ id, accountingPlanId, name }) {
		this.goTo(
			'accounting-account-by-subsidiary-edit',
			{
				params: {
					accountId: id,
					id: accountingPlanId,
					name,
					subsidiaryName: this.subsidiaryName,
					route: 'accounting-accounts-by-subsidiary',
				},
			},
		);
	}

	async function onDelete() {
		try {
			await this.$http.delete(`com-accounting-accounts/${this.accountId}`);
			this.showNotification('La cuenta ha sido eliminada correctamente.');
			this.closeDialog();
			this.params.tree = true;
			this.loadData(`accounting-plan/${this.subsidiaryId}/subsidiary`);
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'ACCOUNTING_ACCOUNT_NOT_FOUND') {
					this.showGenericError('La cuenta no existe.');
				} else if (err.data.message === 'ACCOUNTING_ACCOUNT_DEFINITION_ERROR') {
					this.showGenericError('La cuenta se encuentra asociada a una definición contable.');
				}
			}
		}
	}

	function openConfirmation({ id, fullName }) {
		this.accountId = id;
		this.dialogMessage = `¿Desea eliminar la cuenta ${fullName} del listado?`;
		this.dialog = true;
	}

	function title() {
		return `${this.name} - ${this.$route.meta.title}`;
	}

	function currentSubsidiary(newSub) {
		this.subsidiaryId = newSub.id;
		this.subsidiaryName = newSub.name;
		this.params.tree = true;
		this.loadData(`accounting-plan/${this.subsidiaryId}/subsidiary`);
	}

	async function rowExpanded(row) {
		const { code, details, flagParent } = row;
		if (!details && flagParent) {
			this.$set(row, 'details', await this.loadAccountingDetails(code));
		}
	}

	async function loadAccountingDetails(code) {
		this.loadingAccounts = true;
		const params = {
			tree: true,
			accountingAccountCode: code,
		};
		const { data: response } = await this.$http.get(
			`accounting-plan/${this.subsidiaryId}/subsidiary`,
			{ params },
		);
		this.loadingAccounts = false;
		return response;
	}
	
	function data() {
		return {
			accountId: null,
			checkAll: false,
			columns: [
				{
					id: 1,
					class: 'xs3',
					name: 'Código',
					value: 'account',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 2,
					class: 'xs4',
					name: 'Título',
					value: 'name',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 3,
					class: 'xs3',
					name: 'Descripción',
					value: 'description',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 4,
					class: 'xs2',
					name: 'Acciones',
					checked: true,
					visible: true,
					flagVisible: true,
					movil: false,
				},
			],
			dataSelected: [],
			dialog: false,
			dialogMessage: '',
			loadingAccounts: false,
			subsidiaryId: null,
			subsidiaryName: '',
		};
	}

	export default {
		name: 'accounting-accounts-by-subsidiary',
		components: {
			accountingAccountTable,
		},
		computed: {
			...mapGetters('subsidiary', [
				'currentSubsidiary',
				'getGlobalSubsidiaries',
			]),
			title,
		},
		created,
		data,
		methods: {
			...mapActions('subsidiary', {
				$setCurrentSubsidiary: 'setCurrentSubsidiary',
				$loadSubsidiaries: 'loadSubsidiaries',
			}),
			addAccount,
			closeDialog,
			editAccount,
			loadAccountingDetails,
			onDelete,
			openConfirmation,
			rowExpanded,
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'accounting-accounts-by-subsidiary') {
						if (!this.subsidiaryId) {
							const subsidiary = this.getGlobalSubsidiaries[1];
							this.$setCurrentSubsidiary(subsidiary);
							this.subsidiaryId = subsidiary.id;
						}
						this.params.tree = true;
						this.loadData(`accounting-plan/${this.subsidiaryId}/subsidiary`);
					}
				}
			},
			currentSubsidiary,
		},
	};
</script>

<style lang="scss" scoped>
.mobile-table-accounting {
	@media (max-width: 768px) {
		padding: 0 !important;
		margin: 0 !important;
	}
}

.title-modal {
	color: color(secondary);
	font-size: size(medium18);
	margin: 150px auto 0px;
	max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/accounting-accounts/page-accounting-accounts-by-subsidiary.vue